import fetch from '../api/fetch'

/**
 * 	Action to fetch tracker activity types
 *
 *  @param     {string} URL [/api/v1/dashboard/tracker]
 * 	@method GET
 */

export function fecthTrackerActivityTypes(activityType: string, userId: number) {
    let params = `?activity=${activityType}${(userId) ? '&userId=' + userId : ''}`
    return {
        type: 'FETCH_TRACKER_ACTIVITY_TYPES',
        payload: fetch(`/dashboard/tracker${params}`, { method: 'GET' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/activityTracker.ts